import { useSelector } from 'react-redux'
import { selectGeofencesListStructure } from '@/features/domain/lists'

import { useEditingStateWithCtx } from '@/atoms'
import { useSearchList } from './useSearchList'

export function useFilter() {
  const { editing } = useEditingStateWithCtx('depot')
  const { query, setQuery } = useSearchList()
  const listStructure = useSelector(selectGeofencesListStructure)

  return {
    query,
    editing,
    setQuery,
    noEntries: listStructure.totalItems === 0,
  }
}
